import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../service/api_service';
import { ColumnApi, GridApi } from 'ag-grid-community';
import { Subscription } from 'rxjs'; 

@Component({
  selector: 'app-latedayplanapproval',
  template: require('./latedayplanapproval.component.html'),
  styles: []
})
export class LateDayplanApprovalComponent implements OnInit {

  expDetails: any;
  private columnDefs;
  private rowData;
  private rowHeight;
  api: GridApi;
  busy: Subscription;
  columnApi: ColumnApi;
  defaultColDefine;
  private gridColumnApi;
  private detailCellRendererParams;
  currentMonth: any;

  staffTypes: any;
  staff: any;
  designation: any;
  currentDate: any;


  static parameters = [ApiService]

  constructor(
    private apiService: ApiService

  ) {
    this.columnDefs = [
      { headerName: 'S.No.', field: 'sno', valueGetter: "node.rowIndex + 1", width: 90 },
      { headerName: '', field: 'action', width: 150, checkboxSelection: true, headerCheckboxSelection: true, headerCheckboxSelectionFilteredOnly: true },
      {
        headerName: 'Employee Name', field: "Client_Name"},
      { headerName: 'Designation', field: "Designation" },
      { headerName: 'Head Qtr', field: "HQName" },
      { headerName: 'Day Plan Time', field: "DayPlanTime" },
      { headerName: 'DCR Date', field: "PlanDate" },
     
    ];
    this.defaultColDefine = { resizable: true };
   
    this.rowHeight = 50;
  }

  onFirstDataRendered(params) {
    setTimeout(function () {
      params.api.getDisplayedRowAtIndex(1).setExpanded(false);
    }, 0);
  }

  ngOnInit() {
    this.getStaffTypes();
    // this.getExpDetails();
    var date = new Date();
    this.currentDate = date.getFullYear() + '-' + (date.getMonth() + 1).toString().padStart(2, "0");
    this.currentMonth = this.currentDate;
    console.log('currentDate', this.currentMonth);
    this.LateDayPlanApproval();
  }

  onGridReady = (params) => {
    this.api = params.api;
    this.gridColumnApi = params.columnApi;
    this.api.hideOverlay();
  }

  onBtnExport() {
    this.api.exportDataAsCsv({ fileName: 'LateDayPlanApproval' });
  }

  onFilterTextBoxChanged() {
    this.api.setQuickFilter(document.querySelector<HTMLInputElement>('#filter-text-box')!.value);
    this.api.refreshCells();
  }

  sizeToFit(skipHeader) {
    var allColumnIds = [];
    this.gridColumnApi.getAllColumns().forEach(function (column) {
      allColumnIds.push(column.colId);
    });
    this.gridColumnApi.autoSizeColumns(allColumnIds, skipHeader);
  }

  getStaffTypes() {
    this.apiService.getStaffTypes().subscribe((res: any) => {
      this.staffTypes = res.data;
      console.log('stafftypes ', this.staffTypes);
    })
  }

  getExpDetails() {
    let token = JSON.parse(sessionStorage.getItem("currentUser"));
        //  console.log('token', token);
        var data = {
            Id: token.id
        };
    this.apiService.getEmpDetails(data).subscribe((res: any) => {
      this.expDetails = res.data;
      console.log('empDetails', this.expDetails);
    })
  }

  LateDayPlanApproval() {
    let token = JSON.parse(sessionStorage.getItem("currentUser"));
        console.log(token);
    var queryData = {
      empId: token.clientId
    }
    this.busy = this.apiService.LateDayPlanApproval_web(queryData).subscribe((res: any) => {
      this.rowData = res.data;
      // console.log('this.rowData', this.rowData);
      // this.getChemistForReset();
    })
  }

  approve() {
    var SelectedData = [];
    SelectedData = this.api.getSelectedRows();
    if (SelectedData.length == 0) {
      alert(`Please Select Employee For Approval`);
      return false;
    }
    var alldata = SelectedData.map(item => item.DayPlanId).toString();
    let token = JSON.parse(sessionStorage.getItem("currentUser"));
    var data = { Id: token.clientId, data:alldata };
    this.busy =this.apiService. ApproveLateDayPlan(data).subscribe((res: any) => {
      alert(`Employee Approved  Successfully`);
      this.LateDayPlanApproval();
    })
  }
}
